import { Navigate } from '@tanstack/react-router'
import { Page } from '@/components/layout/Page'
import { ComingSoon } from '@/components/shared/ComingSoon'
import { Card, CardContent } from '@/components/ui/Card'
import { Text } from '@/components/ui/Text'
import { crmNavItem } from '@/lib/crm/crm-nav'
import { useCrmPreviewEnabled } from '@/lib/crm/crm-preview-flag'

/**
 * A CRM tab whose crm-svc module is not built yet (ENT-565). It shows what the page will do and
 * which backend module it waits for. It never reads or writes CRM data. With
 * `VITE_FF_CRM_PREVIEW=false` it sends the caller back to `/crm`.
 */
export function CrmPreviewPage({ navId }: { navId: string }) {
  const previewEnabled = useCrmPreviewEnabled()
  const item = crmNavItem(navId)
  if (!previewEnabled || !item.preview) return <Navigate to="/crm" replace />
  const { title, summary, features, waitsFor } = item.preview

  return (
    <Page crumbs={[{ label: 'CRM', to: '/crm' }, { label: title }]} title={title} subtitle={summary}>
      <div className="flex flex-col gap-4">
        <ComingSoon feature={title} description={`${title} opens when the backend is ready: ${waitsFor}.`} />
        <Card>
          <CardContent>
            <Text variant="title-md" as="h2" className="mb-2">
              What this page will do
            </Text>
            <ul className="list-disc pl-5 space-y-1">
              {features.map((feature) => (
                <li key={feature}>
                  <Text variant="body-md" as="span">
                    {feature}
                  </Text>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </Page>
  )
}
